import { Box, Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import { TwilioPhoneNumber } from "./models";
import { CardSearch } from "@arelia-components/ui-atoms/CardSearch";
import { DataGrid } from "@arelia-components/ui-atoms/data-grid";
import { useState } from "react";
import { useTwilioNumbersForPurchaseAPI } from "./settings.api";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (numberId: string) => void;
};

export default function NumberPurchaseTable({ open, onClose, onSelect }: Props) {
  const [searchValue, setSearchValue] = useState("");
  const { data: numbers = [], isLoading } = useTwilioNumbersForPurchaseAPI(searchValue);

  const columns = [
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      width: "300px",
    },
    {
      field: "location",
      headerName: "Location",
      width: "300px",
      formatter: ({ row }: { row: TwilioPhoneNumber }) => 
        [row.locality, row.region].filter(Boolean).join(", ") || "-"
    },
    {
      field: "actions",
      headerName: "",
      width: "120px",
      renderer: ({ row }: { row: TwilioPhoneNumber }) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleSelect(row.phoneNumber)}
        >
          Select
        </Button>
      ),
    },
  ];

  const handleSelect = (number: string) => {
    onSelect(number);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogTitle>Select Phone Number</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "800px", padding: "16px" }}>
          <CardSearch value={searchValue} onChange={setSearchValue} />
          <Box sx={{ 
            marginTop: 2,
            minHeight: isLoading ? "400px" : "auto",
            display: "flex",
            alignItems: isLoading ? "center" : "flex-start",
            justifyContent: isLoading ? "center" : "flex-start"
          }}>
            <SpinnerWrapper loading={isLoading}>
              <DataGrid
                sx={{ width: "100%" }}
                columns={columns}
                rows={numbers}
              />
            </SpinnerWrapper>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
